import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 2h3v2h-3.7l-5.6 16H15v2H4v-2h3.7l5.6-16H9V2h8z" }));
export default createSvgIcon(iconPath, "Italic");
//# sourceMappingURL=ItalicIcon.js.map